import { NgModule } from '@angular/core';

import {
    CatalogService,
    CategoryService,
    CollageCloudService,
    GroupService,
    JobService,
    JobSiteService,
    LayerService,
    MagnetService,
    ProcessService,
    ProjectService,
    ReportService,
    UploadService,
    UserService,
} from '@mirage-projects/cw-commons';

import { AppCatalogService } from './app-catalog.service';
import { AppCategoryService } from './app-category.service';
import { AppGroupService } from './app-group.service';
import { AppJobSiteService } from './app-job-site.service';
import { AppJobService } from './app-job.service';
import { AppMagnetService } from './app-magnet.service';
import { AppProcessService } from './app-process.service';
import { AppProjectService } from './app-project.service';
import { AppReportService } from './app-report.service';
import { AppUserService } from './app-user.service';
import { AppCollageCloudService } from './collage-cloud/app-collage-cloud.service';
import { AppLayerService } from './layer/app-layer.service';
import { AppUploadService } from './upload/app-upload.service';

@NgModule({
    providers: [
        { provide: ProjectService, useClass: AppProjectService },
        { provide: ReportService, useClass: AppReportService },
        { provide: CategoryService, useClass: AppCategoryService },
        { provide: UploadService, useClass: AppUploadService },
        { provide: UserService, useClass: AppUserService },
        { provide: GroupService, useClass: AppGroupService },
        { provide: JobSiteService, useClass: AppJobSiteService },
        { provide: LayerService, useClass: AppLayerService },
        { provide: CollageCloudService, useClass: AppCollageCloudService },
        { provide: JobService, useClass: AppJobService },
        { provide: MagnetService, useClass: AppMagnetService },
        { provide: ProcessService, useClass: AppProcessService },
        { provide: CatalogService, useClass: AppCatalogService },
    ],
})
export class AppServicesModule {}
